module.exports = __webpack_public_path__ + "img/品質管理4-10.67934220.png";